/** Narrows `val` to a plain object with string-indexed unknown values. */
export function isRecord(val: unknown): val is Record<string, unknown> {
  return typeof val === 'object' && val !== null;
}

/** Narrows `val` to an object with a numeric `status` property (e.g. Axios-style HTTP errors). */
export function hasNumericStatus(val: unknown): val is { status: number } {
  return isRecord(val) && 'status' in val && typeof val.status === 'number';
}
